import { Radio, Group, Stack, Text } from '@mantine/core';

interface Option {
  label: string;
  value: boolean | string;
}

interface CustomRadioGroupProps {
  label: string;
  name?: string;
  options: Option[];
  value?: string | boolean;
  onChange?: (value: string) => void;
  required?: boolean;
  inline?: boolean;
  disabled?: boolean;
}

export const CustomRadioGroup = ({
  label,
  name,
  options,
  value,
  onChange,
  required,
  inline = false,
  disabled
}: CustomRadioGroupProps) => {
  const Wrapper = inline ? Group : Stack;

  const selectedOption = options.find((opt) => String(opt.value) === String(value));

  return (
    <div className="print-radio-group">
      <div className="print-hide">
        <Radio.Group
          mt={10}
          name={name}
          label={label}
          value={String(value ?? '')}
          onChange={onChange}
          readOnly={disabled}
          withAsterisk={required}>
          <Wrapper mt={1}>
            {options.map((opt) => (
              <Radio
                key={String(opt.value)}
                value={String(opt.value)}
                label={opt.label}
                color="dpkk-blue"
                disabled={disabled}
              />
            ))}
          </Wrapper>
        </Radio.Group>
      </div>

      <div className="screen-hide">
        <Text mt={10}>{label}</Text>
        <Text mt={4}>{selectedOption ? selectedOption.label : '—'}</Text>
      </div>
    </div>
  );
};
